import { createContext } from 'react'

import { createResourceBaseTreeStore } from '../store/createStore'

export const MenutTreeStoreContext = createContext<
  ReturnType<typeof createResourceBaseTreeStore> | undefined
>(undefined)
